import { Box, Grid, Typography, Button,InputLabel } from "@mui/material";
import React from "react"
import style from "./style";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import SalesList from "./salesList";
import color from "../../../../../constants/color"
import SubHeader from "../../../../../components/SubHeader"
// import {ReactComponent as Download}from "../../../../../assets/ViewLeave-images/download.svg";
import { useNavigate } from "react-router-dom";

import dayjs from "dayjs";

const SalesListPage = () => {

  const navigate = useNavigate()

  const handleNavigate = () => {
    navigate("/dashboard/newSalesOrders")
  }

  
  return (
    <>
      <Box px="15px" pt="20px" display={{xs: "block", md:"flex"}} justifyContent="space-between" alignItems="center">
        <Typography variant="h5" sx={style.leaveHeading}>Sales List</Typography>

        <Box display="flex" justifyContent={{ xs: "start", md: "end" }} alignItems={{ xs: "start", md: "end" }} mt={{xs:2, md: 0}}>
          <Button variant="contained" color="success" sx={style.checkinBtn} onClick={handleNavigate}>+ Add Sales
          </Button>


        </Box>
      </Box>

      <Grid container spacing={2} px="15px">
        <Grid item md={12} xs={12}>
          <Box sx={style.dateCard}>
            <Box sx={style.formGrid}>
              <Box sx={style.inputBox}>
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <InputLabel sx={style.label}>Start Month</InputLabel>
                  <DatePicker value={dayjs()} maxDate={dayjs().subtract(18, "year")} sx={style.dateInput}
                    slotProps={{
                      field: {
                        readOnly: true
                      }
                    }} />
                </LocalizationProvider>
              </Box>
              <Box sx={style.inputBox}>
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <InputLabel sx={style.label}>End Month</InputLabel>
                  <DatePicker value={dayjs()} maxDate={dayjs().subtract(18, "year")} sx={style.dateInput}
                    slotProps={{
                      field: {
                        readOnly: true
                      }
                    }} />
                </LocalizationProvider>

              </Box>
            </Box>

            <Box> 
              <Button variant="contained" color="success" sx={style.checkinBtn} >
                {"Apply Filter"}
              </Button>
            </Box>
          </Box>
        </Grid>
      </Grid>

      <Box sx={{ backgroundColor: color.card, m: 2, borderRadius: "20px" }}>
        <SubHeader
          title="Invoices"

          isShow={false}
          search
          sortBy
        />
        <SalesList />
    

      </Box>

    </>
  )
}

export default SalesListPage;